module.exports = __webpack_public_path__ + "static/media/N15.b57d337d.jpg";